const capitalizeEachWord = (string) => {
  return string
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default capitalizeEachWord;
